import React from 'react';
import { Box, Skeleton, Stack, Grid, Card, CardContent } from '@mui/material';

interface LoadingSkeletonProps {
  variant?: 'list' | 'show' | 'card';
  rows?: number;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ 
  variant = 'list', 
  rows = 5 
}) => {
  if (variant === 'list') {
    return (
      <Box>
        <Stack spacing={2} mb={3}>
          <Skeleton variant="rectangular" height={56} />
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={3}>
                <Skeleton variant="text" height={40} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton variant="text" height={40} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton variant="text" height={40} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton variant="text" height={40} />
              </Grid>
            </Grid>
            {Array.from({ length: rows }).map((_, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={3}>
                    <Skeleton variant="text" height={30} />
                  </Grid>
                  <Grid item xs={3}>
                    <Skeleton variant="text" height={30} />
                  </Grid>
                  <Grid item xs={3}>
                    <Skeleton variant="circular" width={80} height={30} />
                  </Grid>
                  <Grid item xs={3}>
                    <Stack direction="row" spacing={1}>
                      <Skeleton variant="rectangular" width={30} height={30} />
                      <Skeleton variant="rectangular" width={30} height={30} />
                      <Skeleton variant="rectangular" width={30} height={30} />
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    );
  }

  if (variant === 'show') {
    return (
      <Stack spacing={3}>
        <Skeleton variant="text" height={60} width="60%" />
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card>
              <CardContent>
                <Stack spacing={2}>
                  {Array.from({ length: 6 }).map((_, index) => (
                    <Box key={index}>
                      <Skeleton variant="text" width="30%" height={20} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="70%" height={30} />
                    </Box>
                  ))}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Skeleton variant="rectangular" height={200} sx={{ mb: 2 }} />
                <Stack spacing={1}>
                  <Skeleton variant="text" height={20} />
                  <Skeleton variant="text" height={20} />
                  <Skeleton variant="text" height={20} />
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    );
  }

  if (variant === 'card') {
    return (
      <Card>
        <CardContent>
          <Skeleton variant="rectangular" height={120} sx={{ mb: 2 }} />
          <Skeleton variant="text" height={30} width="80%" sx={{ mb: 1 }} />
          <Skeleton variant="text" height={20} width="60%" />
        </CardContent>
      </Card>
    );
  }

  return null;
};